import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-reaction-diffusion-systems',
  templateUrl: './reaction-diffusion-systems.component.html',
  styleUrls: ['./reaction-diffusion-systems.component.scss']
})
export class ReactionDiffusionSystemsComponent implements OnInit {

  exposition: CardContent = {
    title: 'Reaction Diffusion Systems',
    subtitle: 'Running Turing-McCabe Patterns with WebGL on the GPU',
    image_source: 'assets/images/PatternBanner.png',
  };

  constructor() { }

  ngOnInit(): void {
  }

}
